import * as z from "zod";

export const InventoryGeneralFlatTeamSettingsSchema = z.object({});
